import { Component, OnChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { InvoiceModel } from '@app/core/models/invoices/invoice.model';
import { InvoiceService } from '@app/core/services/invoice.service';
import { FileDownloadService } from '@app/core/services/filedownload.service';
import { Observable } from 'rxjs';
import { HttpCancelService } from '@app/core/services/http-cancel.service';
import { ObjectListBaseComponent } from '@app/core/base/object-list.component';

@Component({
    selector: 'app-invoice-list',
    templateUrl: './invoice-list.component.html',
    styleUrls: ['./invoice-list.component.scss']
})
export class InvoiceListComponent extends ObjectListBaseComponent<InvoiceModel> implements OnChanges {
   constructor(public dialog: MatDialog,
    protected invoiceService: InvoiceService,
        protected httpCancelService: HttpCancelService,
        protected fileDownloadService: FileDownloadService) {
            super(dialog, httpCancelService, fileDownloadService)
        }

    getAttachments(selectedIds: any, massDownloadRequest: any): Observable<Blob> {
        return this.invoiceService.getInvoicesAttachment(selectedIds, massDownloadRequest);
    }
}
